// Feature projects component
const FeatureProjects = () => {
    // Getting motion
    const { inView } = Motion;

    // Animation
    const animation = () => {
        const featuredElement = document.getElementById('featuredAnimation1');
        const featuredElementSlider = document.getElementById('featuredAnimationSlider');

        featuredElement.classList.add('animated');

        setTimeout(() => {
            featuredElement.classList.add('animate-cards');
        }, 1500);

        setTimeout(() => {
            featuredElement.classList.add('fadeOut');
            featuredElementSlider.classList.add('fadeIn');
            // Init feature carousel
            new Swiper('.featuredSlider', {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 1500,
                    disableOnInteraction: false,
                },
                speed: 1000,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                },
            });
        }, 2500);
    };

    // On scroll
    inView(".featuredSection", animation, {
        amount: 0.5
    });
};

// Export component
export default FeatureProjects;